import { useEffect, useRef } from 'react';
import { isAnyModalOpen } from '@mm/state/selectors/modalSelector';
import { useSelector } from 'react-redux';

type Params = {
  editMode: boolean;
  setEditMode: (editMode: boolean, event?: MouseEvent) => void;
};

export const useTrackReplyOutsideClick = (params: Params) => {
  const replyInputHotSpotRef = useRef<HTMLDivElement>(null);
  const clickStartedOutsideInputHotSpotRef = useRef(false);
  const paramsRef = useRef(params);
  paramsRef.current = params;

  const modalOpen = useSelector(isAnyModalOpen);

  useEffect(() => {
    const onMouseDown = (event: MouseEvent) => {
      clickStartedOutsideInputHotSpotRef.current = !(
        replyInputHotSpotRef.current &&
        !replyInputHotSpotRef.current.contains(event.target as Node)
      );
    };

    const handleClick = (event: MouseEvent) => {
      const { editMode, setEditMode } = paramsRef.current;

      const matchesHotSpot = replyInputHotSpotRef.current?.contains(
        event.target as Node,
      );

      if (editMode) {
        if (
          !modalOpen &&
          !matchesHotSpot &&
          !clickStartedOutsideInputHotSpotRef.current
        ) {
          setEditMode(false, event);
        }
      }
    };

    window.addEventListener('mousedown', onMouseDown, true);
    window.addEventListener('click', handleClick, true);

    return () => {
      window.removeEventListener('click', handleClick, true);
      window.removeEventListener('mousedown', onMouseDown, true);
    };
  }, [modalOpen]);

  return {
    replyInputHotSpotRef,
  };
};
